export const authScreens = {
  accesoDirecto: {
    loading: "Accesso al tuo account in corso…",
  },
  confirmar: {
    verifying: "Verifica dell'account in corso…",
    verifiedSuccess: "Account verificato con successo",
    tokenInvalid: "Il token non esiste o è già scaduto",
    backHome: "Torna alla Home",
  },
  recovery: {
    title: "Reimposta password",
    successTitle: "Fatto!",
    successDesc:
      "La tua password è stata modificata con successo. Reindirizzamento alla pagina iniziale…",
    infoTitle: "Crea una nuova password",
    infoDesc:
      "La modifica disconnetterà tutte le sessioni attive sugli altri tuoi dispositivi.",
    newPasswordLabel: "Nuova password",
    newPasswordPlaceholder: "Inserisci la tua nuova password",
    togglePasswordAria: "Mostra/nascondi password",
    confirmPasswordLabel: "Ripeti password",
    confirmPasswordPlaceholder: "Ripeti la tua nuova password",
    passwordsMismatch: "Le password non corrispondono.",
    submit: "Cambia password",
    submitting: "Elaborazione in corso…",
    backToStart: "Torna all'inizio",
    footerWeb: "Sito web",
    toastInvalidLink: "Il link di recupero non è valido o è scaduto.",
    errorGeneric: "Non è stato possibile modificare la password.",
  },
};
